import axios, { AxiosResponse } from 'axios'
import {
  FormularioDtoTipoAtendimentoCreate,
  FormularioDtoUpdateSituacao,
  FormulariosQueryResponse,
  FormularioTipoAtendimentView,
} from './_models'
import { ID } from '../../../../../../_metronic/helpers'
import { FormularioView } from '../../formularios-create/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const FORMULARIOS_URL = `${API_URL}/formularios`
const FORMULARIOS_EMPRESA_URL = `${API_URL}/formularios/empresa`

export const getFormularios = (query?: string): Promise<FormulariosQueryResponse> => {
  return axios
    .get(`${FORMULARIOS_URL}?${query}`)
    .then((d: AxiosResponse<FormulariosQueryResponse>) => d.data)
}

/**
 * Busca todos os formulários da empresa
 * @param query string
 * @returns FormulariosQueryResponse
 */
export const getFormulariosByEmpresa = (query?: string): Promise<FormulariosQueryResponse> => {
  return axios
    .get(`${FORMULARIOS_EMPRESA_URL}?${query}`)
    .then((d: AxiosResponse<FormulariosQueryResponse>) => d.data)
}

/**
 * Remove formulário
 * @param id ID Formulario
 * @returns void
 */
export const deleteFormularioOfEmpresaById = (id: number): Promise<void> => {
  return axios.delete(`${FORMULARIOS_EMPRESA_URL}/${id}`).then((d: AxiosResponse<void>) => d.data)
}

export const deleteFormularioById = (id: ID): Promise<FormulariosQueryResponse> => {
  return axios
    .delete(`${FORMULARIOS_URL}/${id}`)
    .then((d: AxiosResponse<FormulariosQueryResponse>) => d.data)
}

/**
 * Ativa ou inativa um formulário
 * @param empresaId ID da Empresa
 * @param data FormularioDtoUpdateSituacao
 * @returns FormularioView
 */
export const toggleStatusOfEmpresaFormulario = (
  empresaId: number,
  data: FormularioDtoUpdateSituacao
): Promise<FormularioView> => {
  return axios
    .patch(`${FORMULARIOS_EMPRESA_URL}/${empresaId}`, data)
    .then((d: AxiosResponse<FormularioView>) => d.data)
}

export const toggleStatus = (formulario: {
  ativo: boolean
  id: ID
}): Promise<FormulariosQueryResponse> => {
  return axios
    .patch(`${FORMULARIOS_URL}`, formulario)
    .then((d: AxiosResponse<FormulariosQueryResponse>) => d.data)
}

/**
 * Vincula formulário a empresa
 * @param data FormularioDtoTipoAtendimentoCreate
 * @returns FormularioTipoAtendimentView
 */
export const vinculaFormulario = (
  data: FormularioDtoTipoAtendimentoCreate
): Promise<FormularioTipoAtendimentView> => {
  return axios
    .post(`${FORMULARIOS_URL}/tipos`, data)
    .then((d: AxiosResponse<FormularioTipoAtendimentView>) => d.data)
}
